export default __webpack_public_path__ + "41d2cff41cf99411214f6f8f847f859a.svg";